import { gql } from '@apollo/client'

export const RENEW_SUBSCRIPTION = gql`
  mutation RenewSubscription($subscriptionId: String!) {
    renewSubscription(subscriptionId: $subscriptionId)
  }
`
